import {
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Switch,
  Typography,
} from "@mui/material";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import StarIcon from "@mui/icons-material/Star";

const OrganizationFavouriteLocationListItem = ({
  id,
  displayName,
  address,
  onDeleteClick,
}: {
  id: string;
  displayName: string;
  address: string;
  onDeleteClick: (organizationFavouriteLocation: any) => void;
}) => {
  return (
    <ListItem divider>
      <ListItemIcon>
        <StarIcon sx={{ color: "rgb(242, 104, 34)" }} />
      </ListItemIcon>
      <ListItemText primary={displayName} secondary={address} />
      <ListItemSecondaryAction>
        <IconButton onClick={onDeleteClick}>
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default OrganizationFavouriteLocationListItem;
